import {
  CollectCampaignGlobalStateInterface,
  ValidationErrors,
} from "@pages/Contents/Corporate/CollectCampaigns/types";

export const validateStep1 = (
  //STEP GENERAL INFORMATIONS
  state: CollectCampaignGlobalStateInterface,
): ValidationErrors => {
  let errors: ValidationErrors = {};
  if (!state.general?.name) {
    errors.name = "required_name";
  }
  if (!state.general?.target) {
    errors.target = "required_target";
  }
  if (!state.general?.unit) {
    errors.unit = "required_unit";
  }
  return errors;
};

export const validateStep3 = (
  //STEP LEARNING OBJECTS
  state: CollectCampaignGlobalStateInterface,
): ValidationErrors => {
  let errors: ValidationErrors = {};
  // if (state?.lo_selected === "true" && state?.learningObjects.length === 0)
  //   errors.learningObjects = "required_learning_objects";

  return errors;
};

export const validateStep4 = (
  //STEP USERS
  state: CollectCampaignGlobalStateInterface,
): ValidationErrors => {
  let errors: ValidationErrors = {};
  // if (
  //   !state.flagUsersAll &&
  //   (!state.usersGroups || state.usersGroups.length === 0)
  // ) {
  //   errors.usersGroups = "required_users_groups";
  // }
  return errors;
};

export const validateStep5 = (
  //STEP TEMPLATE
  state: CollectCampaignGlobalStateInterface,
  idCampaign?: string,
): ValidationErrors => {
  let errors: ValidationErrors = {};

  // if (!state.template?.zip && !idCampaign) {
  //   errors.template = "required_template_file";
  // }

  return errors;
};
